module.exports = __webpack_public_path__ + "img/logo.75d7bf09.svg";